export enum SearchModalState {
  INITIAL = 'INITIAL',
  FAVORITE = 'FAVORITE',
  VIDEO = 'VIDEO',
  TARGETS = 'TARGETS',
  EATEN = 'EATEN',
  JOIN = 'JOIN'
}
